const KVKK = () => {
  return (
    <div className="Modaltext">
      <p>
        OTO PLAN Kişisel Verilerin Korunması ve İşlenmesi Hakkında
        <br />
        Aydınlatma Metni
        <br />
        Bu bilgilendirme metni 6698 sayılı Kişisel Verilerin Korunması Kanunu
        (Kanun) kapsamında Oto Plan Operasyonel Taşıt Kiralama Ticaret A.Ş.
        tarafından elde edilen kişisel verilerinize y&ouml;nelik olarak
        bilgilendirme amacıyla hazırlanmıştır.
        <br />
        Sadece kurumsal şirketlere operasyonel filo kiralama hizmetleri veren
        Oto Plan, ara&ccedil; filosu, &uuml;st&uuml;n teknolojisi, y&uuml;ksek
        marka kalitesi, alanlarında uzman ve dinamik insan kaynağı, &uuml;lke
        genelinde yayılmış yetkili servis noktaları, 7/24 acil servis ve mobil
        destek, raporlama hizmetleri sunan bir operasyonel kiralama şirketidir.
        <br />
        Bu faaliyet i&ccedil;erisinde gerek şirket i&ccedil;i işleyiş gereği
        toplanan, gerekse sunulan hizmet kapsamında hizmet alan şirketlerin Oto
        Plan aracı kullanan personellerine ilişkin kişisel veriler, bu metninde
        belirtildiği şekilde toplanmakta ve işlenebilmektedir.
        <br />
        Oto Plan, kişisel verilerin hukuka uygun olarak toplanması, saklanması
        ve işlenmesini sağlamak ve gizliliğini korumak amacıyla m&uuml;mk&uuml;n
        olan en &uuml;st seviyede g&uuml;venlik tedbirlerini almakla birlikte,
        kullanıcıların kişisel verileri aşağıda a&ccedil;ıklanan kapsam ve
        koşullar dışında işlenmemektedir.
        <br />
        Oto Plan, Kişisel Verilerin Korunması Hakkında Kanun kapsamındaki bu
        h&uuml;k&uuml;mleri dilediği zaman web sitesi &uuml;zerinden yayımlamak
        suretiyle g&uuml;ncelleyebilir ve/veya değiştirebilir. Bu halde yapılan
        g&uuml;ncelleme ve değişiklikler web sitesinde yayınlandığı tarihten
        itibaren ge&ccedil;erli olacaktır.
        <br />
        Veri Sorumlusu
        <br />
        Kişisel Verilerin Korunması Kanunu uyarınca, kişisel verileriniz; veri
        sorumlusu olarak Oto Plan tarafından bu metinde belirtilen şekilde
        toplanacak ve işlenir.
        <br />
        Kişisel Veri
        <br />
        Toplanan Kişisel Veriler
        <br />
        Oto Plan&rsquo;ın topladığı veriler, kullanılan Oto Plan hizmetlerine ve
        &ouml;zelliklere bağlı olarak değişmektedir.
        <br />
        Ad ve İletişim Bilgileri: Ad, soyadı, cep telefonu, ev telefonu, iş
        telefonu, adresi, e-posta adresi, fatura bilgileri, TC kimlik numarası
        (ulusal kimlik numarası), kimlik fotokopisi, ehliyet ve benzer diğer
        belgeler.
        <br />
        Demografik Veriler: Doğum tarihi, yaş, cinsiyet, medeni hali, eğitim
        durumu, meslek, ilgi alanları, tercih edilen dil verileri.
        <br />
        Kullanım Verileri : &ccedil;eşitli sebeplerle doğrudan Oto Plan&rsquo;ı
        veya &ccedil;ağrı Merkezlerini arama nedenleriniz, bu g&ouml;rşmeler
        sırasında alınan ses kayıtları, kullanım bilgileri, aracın kullanıldığı
        tarih ve saat verileri, bulunduğunuz lokasyona ilişkin il, il&ccedil;e,
        semt, mahalle, adres bilgileri, tercih edilen geri d&ouml;n&uuml;ş
        metodu ve tarihi, cevap verilen kanallar, ziyaret edilen internet
        sitesi, g&ouml;r&uuml;nt&uuml;lenen sayfa sayısı, ziyaret s&uuml;resi ve
        hedef tamamlama sayısı, web sitesinde girilen arama terimleri, ziyaret
        edilen hizmet bilgileri, hizmet kullanımı sırasında oluşan hataların
        kayıtları gibi telefon veya web sitesinde bırakılan izler.
        <br /> <br />
        Kişisel Veriler Nerede Depolanır ve İşlenir
        <br />
        Oto Plan tarafından toplanan kişisel veriler yurti&ccedil;inde veya
        yurtdışında ya da bağlı kuruluşlarının, alt kuruluşlarının veya
        işbirliği i&ccedil;inde bulunduğu hizmet servis sağlayıcılarının tesisi
        bulunan başka bir &uuml;lkede depolanabilir ve bu metindeki
        ama&ccedil;lar doğrultusunda ve bu ama&ccedil;larla işlenebilir.
        <br />
        Kişisel Verilerin Hangi Ama&ccedil;la İşleneceği
        <br />
        Kişisel veriler, Oto Plan ile iş ilişkisi i&ccedil;erisinde olan
        &uuml;&ccedil;&uuml;nc&uuml; ger&ccedil;ek/t&uuml;zel kişiler ile
        yapılan s&ouml;zleşmeler, y&uuml;r&uuml;t&uuml;len faaliyetler ile yasal
        d&uuml;zenlemelerden doğan y&uuml;k&uuml;ml&uuml;l&uuml;kler
        &ccedil;er&ccedil;evesinde hukuki ve ticari
        y&uuml;k&uuml;ml&uuml;l&uuml;klerin yerine getirilmesi i&ccedil;in, Oto
        Plan tarafından iş ortağı/m&uuml;şteri/tedarik&ccedil;iler ile yapılan
        s&ouml;zleşmelerden kaynaklanan y&uuml;k&uuml;ml&uuml;l&uuml;kleri ifa
        etme, hak tesis etme, hakları koruma, ticari ve hukuki değerlendirme
        s&uuml;re&ccedil;lerini y&uuml;r&uuml;tme, hukuki ve ticari risk
        analizleri yapma, hukuki uyum s&uuml;recini y&uuml;r&uuml;tme, mali
        işleri y&uuml;r&uuml;tme, yasal gereklilikleri yerine getirme, yetkili
        kurum, kuruluş ve mercilerin kararlarını yerine getirme, taleplerini
        cevaplama, ama&ccedil;ları ile 6698 Sayılı Kişisel Verilerin Korunması
        Kanunu&rsquo;nun 5. Ve 6. maddesinde d&uuml;zenlenen İlkeler ve İşleme
        Şartları uyarınca ve aşağıda detayları belirtilen ama&ccedil;larla
        işlenmektedir.
        <br />
        &bull; Mevzuattan kaynaklanan y&uuml;k&uuml;ml&uuml;l&uuml;klerin yerine
        getirilmesi,
        <br />
        &bull; İş ortakları ve/veya tedarik&ccedil;ilerle olan ilişkilerin
        y&ouml;netimi,
        <br />
        &bull; S&ouml;zleşme s&uuml;re&ccedil;lerinin ve/veya hukuki taleplerin
        takibi
        <br />
        &bull; Yetkili makamlarca y&ouml;nlendirilecek hukuki ve cezai
        s&uuml;re&ccedil;ler,
        <br />
        &bull; Sigorta şirketleri ile y&uuml;r&uuml;t&uuml;len hasar
        işlemlerinin takibi ve sonu&ccedil;landırılası,
        <br />
        Kişisel Verileri Saklama S&uuml;resi
        <br />
        Kişisel veriler bu metinde belirtilen ama&ccedil;larla verilen hizmetin
        mahiyetinden kaynaklanan y&uuml;k&uuml;ml&uuml;l&uuml;klerin yerine
        getirebilmesi maksadıyla, işlendikleri ama&ccedil; i&ccedil;in gerekli
        olan s&uuml;re kadar ve en &ccedil;ok 5(Beş) yıl s&uuml;reyle muhafaza
        edecektir.
        <br />
        Oto Plan, kiralama hizmetinden kaynaklanan hukuki veya cezai herhangi
        bir uyuşmazlık durumunda, uyuşmazlık kapsamında idari veya yargı
        s&uuml;recinin y&uuml;r&uuml;t&uuml;lebilmesi, takibi ve
        sonu&ccedil;landırılması amacıyla sınırlı olmak &uuml;zere ve ilgili
        mevzuatta belirlenen zamanaşımı s&uuml;resi boyunca kişisel verileri
        saklayacaktır.
        <br />
        İşlenen Kişisel Verilerin Kimlere ve Hangi Ama&ccedil;la
        Aktarılabileceği
        <br />
        Kişisel veriler aşağıda belirtilen taraflar ve paylaşım ama&ccedil;ları
        ile sınırlı olmak &uuml;zere Kanun'un 8. ve 9. maddelerinde belirtilen
        şartlar dahilinde paylaşılmaktadır.
        <br />
        Kiralama S&ouml;zleşmesi gereklerini ve hizmetleri ifa etmek, kullanıcı
        deneyimini geliştirmek (iyileştirme ve kişiselleştirme dahil),
        kullanıcıların g&uuml;venliğini sağlamak, hizmetleri geliştirmek,
        operasyonel değerlendirme araştırması yapmak, hataları gidermek,
        kullanıcı kimliklerini doğrulamak, sistem performansını geliştirmek,
        hasar dosyalarını sonu&ccedil;landırmak, ara&ccedil; ruhsatı ve
        poli&ccedil;esi gibi &ouml;zel belgeleri kullanıcıya ulaştırmak, yol
        yardım ve destek hizmeti sunmak gibi kullanıcıa destek olmak &uuml;zere
        yukarıda işleme ama&ccedil;ları kısmında belirtilen ama&ccedil;lardan
        herhangi birini ger&ccedil;ekleştirebilmek i&ccedil;in dış kaynak hizmet
        sağlayıcılar, kargo şirketleri, hukuk b&uuml;roları, araştırma
        şirketleri, &ccedil;ağrı merkezleri, lojistik firmaları, &uuml;retici,
        distr&uuml;bit&ouml;r, bayiiler, otomotiv şirketleri, sigorta
        şirketleri, şikayet y&ouml;netimi ve g&uuml;venliğin sağlanmasına
        ilişkin yazılım şirketleri, danışmanlık şirketleri, basım
        sekt&ouml;r&uuml;nde yer alan şirketler, bankalar, bağımsız denetim
        şirketleri, gibi &uuml;&ccedil;&uuml;nc&uuml; ger&ccedil;ek ve/veya
        t&uuml;zel kişiler ile ve yasal zorunluluklar kapsamında yetkili kurum,
        kuruluş, merci, idari ve yargı organları ile paylaşabilecektir.
        <br />
        Kişisel Veri Toplamanın Y&ouml;ntemi ve Hukuki Sebebi
        <br />
        Kişisel verileriniz e-mail, formlar, web siteleri, kartvizit, telefon,
        s&ouml;zleşme, taşıt teslim formları, trafik kaza tutanakları gibi
        hizmet kanallarından doğrudan veya dolaylı şekilde yasal veya
        s&ouml;zleşme kaynaklı hukuki sebeplerden dolayı temin edilebilir.
        <br />
        Veri G&uuml;venliğine İlişkin &ouml;nlemler ve Taahh&uuml;tler
        <br />
        Oto Plan, kişisel verileri g&uuml;venli bir şekilde korumayı
        taahh&uuml;t eder. Kişisel verilerin hukuka aykırı olarak işlenmesini ve
        erişilmesini engellemek ve kişisel verilerin muhafazasını sağlamak
        amacıyla uygun g&uuml;venlik d&uuml;zeyini temin etmeye y&ouml;nelik
        teknik ve idari tedbirleri &ccedil;eşitli y&ouml;ntemler ve
        g&uuml;venlik teknolojileri kullanarak ger&ccedil;ekleştirilmektedir.
        <br />
        Oto Plan, elde ettiği kişisel verileri 6698 Sayılı Kişisel Verilerin
        Korunması Kanunu h&uuml;k&uuml;mlerine aykırı olarak
        a&ccedil;ıklamayacak ve işleme amacı dışında kullanmayacaktır. Bu metin
        kapsamında dış kaynak hizmet sağlayıcılarla kullanıcılara ait kişisel
        verilerin paylaşılması durumunda, s&ouml;z konusu dış kaynak
        tedarik&ccedil;ilerinin de bu metinde yer alan taahh&uuml;tlere riayet
        etmeleri i&ccedil;in gerekli uyarılarda bulunacaktır.
        <br />
        Kullanıcı, Oto Plan&rsquo;la paylaştığı bilgilerinin tam, doğru ve
        g&uuml;ncel olduğunu, bu bilgilerde herhangi bir değişiklik olması
        halinde bunları Oto Plan iletişim kanalları &uuml;zerinden
        g&uuml;ncelleyeceğini taahh&uuml;t eder. Kullanıcının bilgilerini
        g&uuml;ncellememiş olması halinde Oto Plan&rsquo;ın herhangi bir
        sorumluluğu olmayacaktır.
        <br />
        Kişisel Veri Sahibinin 6698 sayılı Kanun&rsquo;un 11. Maddesi
        Kapsamındaki Hakları
        <br />
        Kişisel veri sahipleri olarak, haklarınıza ilişkin taleplerinizi,
        info@otoplan.com.tr adresi &uuml;zerinden veya Oto Plan iletişim
        kanallarını kullanarak Oto Plan&rsquo;a iletmeniz durumunda Oto Plan,
        talebin niteliğine g&ouml;re talebi en kısa s&uuml;rede ve en ge&ccedil;
        otuz g&uuml;n i&ccedil;inde &uuml;cretsiz olarak
        sonu&ccedil;landıracaktır. Başvurunuza y&ouml;nelik işlemlerin ayrı bir
        maliyeti gerektirmesi halinde, Kişisel Verileri Koruma Kurulu (Kurul)
        tarafından belirlenen &uuml;cretler tarafınıza fatura edilir. Bu
        kapsamda Kanun&rsquo;un 13. maddesinin 1. fıkrası gereğince, yukarıda
        belirtilen haklarınızı kullanmak ile ilgili talebinizi, yazılı olarak
        veya Kurul&rsquo;un ileride belirleyeceği diğer y&ouml;ntemlerle Oto
        Plan&rsquo;&rsquo;a iletebilirsiniz.
        <br />
        &bull; Kişisel verilerinizin işlenip işlenmediğini &ouml;ğrenme,
        <br />
        &bull; Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
        <br />
        &bull; Kişisel verilerinizin işlenme amacını ve bunların amacına uygun
        kullanılıp kullanılmadığını &ouml;ğrenme,
        <br />
        &bull; Yurt i&ccedil;inde veya yurt dışında kişisel verilerinizin
        aktarıldığı &uuml;&ccedil;&uuml;nc&uuml; kişileri bilme,
        <br />
        &bull; Kişisel verilerinizin eksik veya yanlış işlenmiş olması
        h&acirc;linde bunların d&uuml;zeltilmesini isteme ve bu kapsamda yapılan
        işlemin kişisel verilerinizin aktarıldığı &uuml;&ccedil;&uuml;nc&uuml;
        kişilere bildirilmesini isteme,
        <br />
        &bull; 6698 sayılı Kanun ve ilgili diğer kanun h&uuml;k&uuml;mlerine
        uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin
        ortadan kalkması halinde kişisel verilerinizin silinmesini veya yok
        edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin
        aktarıldığı &uuml;&ccedil;&uuml;nc&uuml; kişilere bildirilmesini isteme,
        <br />
        &bull; İşlenen verilerinizin m&uuml;nhasıran otomatik sistemler
        vasıtasıyla analiz edilmesi suretiyle aleyhine bir sonucun ortaya
        &ccedil;ıktığını d&uuml;ş&uuml;n&uuml;yor iseniz buna itiraz etme,
        <br />
        &bull; Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle
        zarara uğramanız halinde zararınızın giderilmesini talep etme
        <br />
        Başvurunuzda;
        <br />
        1. Adınızın, soyadınızın ve başvuru yazılı ise imzanızın,
        <br />
        2. T&uuml;rkiye Cumhuriyeti vatandaşları i&ccedil;in T.C. kimlik
        numaranızın, yabancı iseniz uyruğunuzun, pasaport numaranızın veya varsa
        kimlik numaranızın,
        <br />
        3. Tebligata esas yerleşim yeri veya iş yeri adresinizin,
        <br />
        4. Varsa bildirime esas elektronik posta adresi, telefon ve faks
        numaranızın,
        <br />
        5. Talep konunuzun bulunması zorunlu olup varsa konuya ilişkin bilgi ve
        belgelerin de başvuruya eklenmesi gerekmektedir.
      </p>
      <p>&nbsp;</p>
    </div>
  );
};
export default KVKK;
